window.GTMTrackerGA4 = (function () {
  'use strict';

  const config = {
    debug: false,
    brand: 'Cosori',
    defaultCurrency: 'USD',
  };

  function log(...args) {
    if (config.debug) {
      // console.log('[GTM GA4]', ...args);
      console.log('[GTM GA4]', JSON.stringify(args));
    }
  }

  function pushGA4Event(eventName, eventParameters = {}) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: eventParameters,
    });

    log('GA4 Event:', eventName, eventParameters);
  }

  function formatItems(items, defaultListName = '') {
    if (!Array.isArray(items)) {
      items = [items];
    }

    return items.map((item) => {
      let variantTitle = item.item_variant || item.variant || '';
      if (variantTitle === 'Default Title') {
        variantTitle = '';
      }

      const listName = item.item_list_name || item.item_list_id || defaultListName;

      return {
        item_id: item.item_id || item.id || '',
        item_name: item.item_name || item.name || '',
        item_brand: config.brand,
        item_category: item.item_category || item.category || '',
        item_variant: variantTitle,
        price: parseFloat(item.price) || 0,
        quantity: parseInt(item.quantity) || 1,
        discount: parseFloat(item.discount) || 0,
        index: item.index || 0,
        item_list_id: listName,
        item_list_name: listName,
      };
    });
  }

  const GA4 = {
    // viewItem: function (itemData, module = '') {
    //   const items = formatItems(itemData, module);
    //   const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

    //   pushGA4Event('view_item', {
    //     currency: config.defaultCurrency,
    //     value: value,
    //     module: module,
    //     items: items,
    //   });
    // },

    viewItemList: function (itemsData, listName = '', module = '') {
      const items = formatItems(itemsData, listName || module);
      const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

      pushGA4Event('view_item_list', {
        item_list_name: listName || module,
        module: module,
        currency: config.defaultCurrency,
        value: value,
        items: items,
      });
    },

    selectItem: function (itemData, params = {}) {
      const listName = params.item_list_id || params.item_list_name || '';
      const items = formatItems(itemData, listName);

      pushGA4Event('select_item', {
        currency: config.defaultCurrency,
        button_name: params.button_name || '',
        items: items,
      });
    },

    // addToCart: function (itemData, params = {}) {
    //   const module = params.module || 'Cart Popup';
    //   const items = formatItems(itemData, module);
    //   const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

    //   pushGA4Event('add_to_cart', {
    //     module: module,
    //     currency: config.defaultCurrency,
    //     value: value,
    //     button_name: params.button_name || '',
    //     items: items,
    //   });
    // },

    // removeFromCart: function (itemData, params = {}) {
    //   const module = params.module || 'Cart Popup';
    //   const items = formatItems(itemData, module);
    //   const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

    //   pushGA4Event('remove_from_cart', {
    //     module: module,
    //     currency: config.defaultCurrency,
    //     value: value,
    //     button_name: params.button_name || '',
    //     items: items,
    //   });
    // },

    viewCart: function (itemsData, params = {}) {
      const module = params.module || 'Cart Popup';
      const items = formatItems(itemsData, module);
      const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

      pushGA4Event('view_cart', {
        module: module,
        currency: config.defaultCurrency,
        value: value,
        items: items,
      });
    },

    beginCheckout: function (itemsData, params = {}) {
      const items = formatItems(itemsData, 'Checkout');
      const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

      pushGA4Event('begin_checkout', {
        currency: config.defaultCurrency,
        value: value,
        coupon: params.coupon || '',
        items: items,
      });
    },

    search: function (searchTerm, elementLocation = '') {
      pushGA4Event('search', {
        element_location: elementLocation,
        search_term: searchTerm,
      });
    },

    scroll: function (percentScrolled) {
      pushGA4Event('scroll', {
        percent_scrolled: percentScrolled,
      });
    },

    cookieInteraction: function (params = {}) {
      pushGA4Event('cookie_interaction', {
        interaction_type: params.interaction_type || '',
        consent_action: params.consent_action || '',
        banner_version: params.banner_version || '',
        button_name: params.button_name || '',
        banner_location: params.banner_location || '',
      });
    },

    viewBanner: function (bannerName, position) {
      pushGA4Event('view_banner', {
        banner_location: position,
        banner_name: bannerName,
      });
    },

    promoStripClick: function (params = {}) {
      pushGA4Event('promo_strip_click', {
        link_url: params.link_url || '',
        link_text: params.link_text || '',
        promo_position: params.promo_position || '',
        path_location: params.path_location || '',
        promo_name: params.promo_name || '',
        button_name: params.button_name || '',
      });
    },

    bannerClick: function (params = {}) {
      pushGA4Event('banner_click', {
        banner_location: params.banner_location || '',
        banner_type: params.banner_type || 'promotional',
        banner_name: params.banner_name || '',
        button_name: params.button_name || 'Banner',
        link_url: params.link_url || ''
      });
    },

    navigationBarClick: function (params = {}) {
      pushGA4Event('navigation_bar_click', {
        link_url: params.link_url || '',
        link_text: params.link_text || '',
        navigation_category: params.navigation_category || '',
        navigation_sub_category: params.navigation_sub_category || '',
        navigation_sub_sub_category: params.navigation_sub_sub_category || '',
      });
    },

    topFunction: function (buttonName) {
      pushGA4Event('top_function', {
        button_name: buttonName,
      });
    },

    selectOtherBrand: function (url, buttonName) {
      pushGA4Event('select_other_brand', {
        link_url: url,
        button_name: buttonName,
      });
    },

    expressCheckout: function (buttonName, module = 'Cart Popup') {
      pushGA4Event('express_checkout', {
        module: module,
        button_name: buttonName,
      });
    },

    floatBar: function (buttonName) {
      pushGA4Event('float_bar', {
        button_name: buttonName,
      });
    },

    generateLead: function (params = {}) {
      pushGA4Event('generate_lead', {
        lead_source: params.lead_source || '',
        lead_type: params.lead_type || '',
        contact_source: params.contact_source || '',
        url: params.url || window.location.href,
      });
    },

    bottomNavigation: function (navigationGroup, navigationName) {
      pushGA4Event('bottom_navigation', {
        navigation_group: navigationGroup,
        navigation_name: navigationName,
      });
    },

    followUs: function (buttonName) {
      pushGA4Event('follow_us', {
        button_name: buttonName,
      });
    },

    login: function (method) {
      pushGA4Event('login', {
        method: method,
      });
    },

    signUp: function () {
      pushGA4Event('sign_up', {});
    },

    selectContent: function (contentType, contentName) {
      pushGA4Event('select_content', {
        content_type: contentType,
        content_name: contentName,
      });
    },

    checkoutButton: function (params = {}) {
      pushGA4Event('checkout_button', {
        module: params.module || '',
        button_name: params.button_name || '',
      });
    },

    selectProduct: function (params = {}) {
      pushGA4Event('select_product', {
        module: params.module || '',
        button_name: params.button_name || '',
        product_name: params.product_name || '',
      });
    },

    // 新增事件方法
    searchBarOpen: function (buttonName) {
      pushGA4Event('search_bar_open', {
        button_name: buttonName,
      });
    },

    subscribe: function (params = {}) {
      pushGA4Event('subscribe', {
        module: params.module || 'Bottom Subscription',
        status: params.status || '',
      });
    },

    goShopping: function (params = {}) {
      pushGA4Event('go_shopping', {
        module: params.module || 'Cart Popup',
        button_name: params.button_name || '',
      });
    },

    clickLogIn: function (params = {}) {
      pushGA4Event('click_log_in', {
        module: params.module || 'Cart Popup',
        button_name: params.button_name || '',
      });
    },

    selectCategory: function (params = {}) {
      pushGA4Event('select_category', {
        module: params.module || '',
        button_name: params.button_name || '',
      });
    },

    chooseOptionsButton: function (params = {}) {
      pushGA4Event('choose_options_button', {
        module: params.module || 'Bundle With',
        product_name: params.product_name || '',
        button_name: params.button_name || '',
      });
    },

    clickTab: function (params = {}) {
      pushGA4Event('click_tab', {
        module: params.module || '',
        button_name: params.button_name || '',
      });
    },

    applyPromoCode: function (params = {}) {
      pushGA4Event('apply_promo_code', {
        button_name: params.button_name || '',
        coupon: params.coupon || '',
        discount: params.discount || '',
        status: params.status || '',
        promo_code_entered: params.promo_code_entered || '',
        error_message: params.error_message || '',
      });
    },

    addContactInfo: function () {
      pushGA4Event('add_contact_info', {});
    },

    addAddressInfo: function () {
      pushGA4Event('add_address_info', {});
    },

    addShippingInfo: function (itemsData, params = {}) {
      const items = formatItems(itemsData, 'Checkout');
      const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

      pushGA4Event('add_shipping_info', {
        currency: config.defaultCurrency,
        value: value,
        coupon: params.coupon || '',
        shipping_tier: params.shipping_tier || '',
        items: items,
      });
    },

    addPaymentInfo: function (itemsData, params = {}) {
      const items = formatItems(itemsData, 'Checkout');
      const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

      pushGA4Event('add_payment_info', {
        currency: config.defaultCurrency,
        value: value,
        coupon: params.coupon || '',
        payment_type: params.payment_type || '',
        items: items,
      });
    },

    purchase: function (itemsData, params = {}) {
      const items = formatItems(itemsData, 'Purchase');
      const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;

      pushGA4Event('purchase', {
        currency: config.defaultCurrency,
        transaction_id: params.transaction_id || '',
        value: value,
        coupon: params.coupon || '',
        vplus_status: params.vplus_status || '',
        bind_card_status: params.bind_card_status || '',
        points_use: params.points_use || 0,
        points_get: params.points_get || 0,
        shipping: params.shipping || 0,
        tax: params.tax || 0,
        order_type: params.order_type || '',
        items: items,
      });
    },

    clickLogOut: function (params = {}) {
      pushGA4Event('click_log_out', {
        button_name: params.button_name || '',
      });
    },

    manageAccount: function (params = {}) {
      pushGA4Event('manage_account', {
        module: params.module || '',
        button_name: params.button_name || '',
      });
    },

    viewBlog: function (params = {}) {
      pushGA4Event('view_blog', {
        blog_category: params.blog_category || '',
        blog_name: params.blog_name || '',
      });
    },

    selectSearchResult: function (params = {}) {
      pushGA4Event('select_search_result', {
        search_term: params.search_term || '',
        content_type: params.content_type || '',
        content_name: params.content_name || '',
      });
    },
  };

  return {
    init: function (options = {}) {
      Object.assign(config, options);
      log('GA4 Tracker initialized', config);
    },
    ...GA4,
    config: config,
    pushEvent: pushGA4Event,
  };
})();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = window.GTMTrackerGA4;
}

